import PropTypes from 'prop-types'
import { validarRangoFechas } from '../../../helpers/dateValidation.js'
import GenericSelect from '../../reutilizables/genericSelect/GenericSelect'
import styles from './Estado.module.css'

const PUBLICACION_VENCIDA = 5
const ESTADO = [
  { idPublicacionEstado: 2, nombre: 'Publicada' },
  { idPublicacionEstado: 3, nombre: 'Pausada' },
  { idPublicacionEstado: 5, nombre: 'Vencida' }
]

const Estado = ({ value, onChange, vigenciaHasta }) => {
  const selectDeshabilitado =
    value === PUBLICACION_VENCIDA && !validarRangoFechas(new Date(), vigenciaHasta, 'day')

  return (
    <div className={styles.container}>
      <span className={styles.label}>Cambiar estado a:</span>
      <GenericSelect
        name="idPublicacionEstado"
        onChange={(val) =>
          onChange(
            {
              currentTarget: { name: 'idPublicacionEstado', value: val, type: 'select' }
            },
            'num'
          )
        }
        value={value}
        className={styles.select}
        options={ESTADO.map((e) => ({
          value: e.idPublicacionEstado,
          label: e.nombre,
          key: e.idPublicacionEstado
        }))}
        placeholder="Seleccionar estado"
        disabled={selectDeshabilitado}
      />
      {selectDeshabilitado && (
        <small className="warningMessage">
          Para modificar el estado de la publicación, es necesario actualizar la fecha de vigencia a
          un día posterior al actual.
        </small>
      )}
    </div>
  )
}

Estado.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  vigenciaHasta: PropTypes.string.isRequired
}

export default Estado
